// extracted by mini-css-extract-plugin
export default {"TooltipItem":"TooltipItem--G8wwV","TooltipItemLabel":"TooltipItemLabel--ZpUMY"};